var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_flag_677766_000000@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin-Entry-Edit-Page/Collapsed",
    transform: "translate(-378.000000, -1728.000000)",
    fill: "#B7844D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(68.000000, 1461.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_flag_677766_000000",
    transform: "translate(310.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,2.98116847e-05 C0.279933333,-0.0037948296 0.0078,0.361144754 0,0.657953251 L0,24.3421068 C0,24.7057573 0.298176667,25 0.666666667,25 C1.03515667,25 1.33333333,24.7057474 1.33333333,24.3421068 L1.33333333,11.8421369 L8,11.8421369 L8,13.8158164 C8,14.1781839 8.29817667,14.4737095 8.66666667,14.4737095 L19.3333333,14.4737095 C19.7018333,14.4737095 20,14.1781708 20,13.8158164 L20,3.28952587 C20,2.92587543 19.7018233,2.63163272 19.3333333,2.63163272 L14.6666667,2.63163272 L14.6666667,0.657953251 C14.6666667,0.313579079 14.34896,2.98116847e-05 14,2.98116847e-05 L0.666666667,2.98116847e-05 Z M1.33333333,1.31584641 L13.3333333,1.31584641 L13.3333333,10.5263506 L1.33333333,10.5263506 L1.33333333,1.31584641 Z M14.6666667,3.94741903 L18.6666667,3.94741903 L18.6666667,13.1579232 L9.33333333,13.1579232 L9.33333333,11.8421369 L14,11.8421369 C14.3489667,11.8421369 14.6666667,11.5286113 14.6666667,11.1842437 L14.6666667,3.94741903 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.ff955ffd43f20bb70c6139c2ce001385.svg";
export { ForwardRef as ReactComponent };